import React, {useState} from "react";
import { Link, useLocation } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import CommonUtil from "../../../../utils/CommonUtil";
import UIUtils from "utils/UIUtils";
import userStore from "../../../../common/user/store/UserStore";
import userRepository from "../../../../common/user/repository/UserRepository";



function ContentsContainer() {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const crtfcId = params.get("id");
	const crtfcCode = params.get("code");
	const [flag, setFlag] = useState(false);

	async function updagteCrtfc() {

		const response:any = await CommonUtil.execute({
			url: "usr_1204.jct",
			data: { CRTFC_ID: crtfcId,
					CRTFC_CODE: crtfcCode
				  }
		}).then(() => {
			UIUtils.alert("이메일 인증이 완료되었습니다.").then();
			setFlag(true);
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
		});
	}

	React.useEffect(() => {
		userRepository.logout().then();
		userStore.clearUserStoreNoReplace();
	}, []);

	React.useEffect(() => {
		console.log(crtfcId, crtfcCode);

		if(crtfcId != null && crtfcCode != null){
			updagteCrtfc();
		}

	}, [])

	return (
		<PageContainer session={false}>
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">회원가입</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<div className="member-join">
						<h1 className="tx tx-hd2">회원가입</h1>
						<ul className="join-step">
							<li>STEP 1. 약관동의 및 인증</li>
							<li>STEP 2. 회원정보 입력</li>
							<li className="active">STEP 3. 가입완료</li>
						</ul>
						<div className="join-complete">
							{flag === false ? (
								<>
									<h3><span className="fc-pri">회원가입</span> 요청이 완료되었습니다.</h3>
									<p className="sub-txt">
										입력하신 메일로 <span className="fc-pri">인증메일</span>이 발송되었습니다.<br />
										인증메일의 링크를 <span className="fc-pri">클릭</span>하여 인증을 완료하시면 이용이 가능합니다.
									</p>
								</>
								) : (
								<>
									<h3><span className="fc-pri">이메일 인증</span>이 완료되었습니다.</h3> <br/>
								</>
							)
							}
							<div className="hz-root hz-center">
								<Button color='pri' size="big" href="/main/usr_1000/usr_1300">로그인 페이지로 이동</Button>
							</div>
						</div>
					</div>
				</main>
			</div>				
		</PageContainer>
	);
}
export default ContentsContainer;